import { useState } from "react";
import { KLAVIYO_COMPANY_ID } from "utils/constants";
import axios from "axios";

const config = (listId, profileAttributes) => ({
	method: "POST",
	url: `https://a.klaviyo.com/client/subscriptions/?company_id=${KLAVIYO_COMPANY_ID}`,
	headers: {
		"Content-Type": "application/json",
		"revision": "2023-08-15",
	},
	data: {
		data: {
			type: "subscription",
			attributes: {
				profile: {
					data: {
						type: "profile",
						attributes: profileAttributes,
					},
				},
			},
			relationships: {
				list: {
					data: {
						type: "list",
						id: listId,
					},
				},
			},
		},
	},
});

const useKlaviyoSubscription = (listId,  isPhoneNumber = false) => {
	const [success, setSuccess] = useState(false);
	const [error, setError] = useState("");
	const [identifier, setIdentifier] = useState("");

	const handleSubscribe = async (e, profileAttributes) => {
		e.preventDefault();
		setError("");
		
		if (!isPhoneNumber && invalidEmail(identifier)) {
			setError("Please enter a valid email address");
			return;
		}

	
		try {
			const response = await axios(config(listId, profileAttributes));
			console.log("Klaviyo API response:", response);
	
			if (response.status === 202) {
				setSuccess("Thanks for subscribing!");
				return { success: true };
			} else {
				setError("An error occurred. Please try again later.");
			}
		} catch (err) {
			console.log({ err });
			setError(err.response?.data?.errors?.[0].detail );
		}
	};
	
	const invalidEmail = (email) => {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return !emailRegex.test(email);
	};
	const onChange = (value) => {
		setIdentifier(value);
		setError("");
	};

	return {
		success,
		email: !isPhoneNumber ? identifier : "",
		phoneNumber: isPhoneNumber ? identifier : "",
		error,
		handleSubscribe,
		onChange
	};
};

export default useKlaviyoSubscription;
